import React, { useState } from 'react';
import './AddTextModal.css';

function AddTextModal({ isOpen, onClose, onSave, currentText, imageName }) {
  const [text, setText] = useState(currentText || '');
  const [isSaving, setIsSaving] = useState(false);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!text.trim()) {
      alert('⚠️ الرجاء إدخال النص أولاً');
      return;
    }

    setIsSaving(true);
    try {
      await onSave(text);
      onClose();
    } catch (error) {
      console.error('Error saving text:', error);
      alert('❌ حدث خطأ أثناء حفظ النص');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="add-text-modal-overlay" onClick={onClose}>
      <div className="add-text-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="add-text-modal-header">
          <h2 className="add-text-modal-title">
            📝 إضافة التفريغ النصي
          </h2>
          <button className="close-modal-btn" onClick={onClose}>
            ✖️
          </button>
        </div>
        
        <div className="add-text-modal-body">
          <div className="image-name-display">
            <span className="label">التصميم:</span>
            <span className="value">{imageName}</span>
          </div>
          
          <div className="textarea-container">
            <label htmlFor="extracted-text">التفريغ النصي:</label>
            <textarea
              id="extracted-text"
              className="text-input"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="اكتب أو الصق التفريغ النصي هنا..."
              rows="15"
              disabled={isSaving}
            />
            <div className="char-count">
              عدد الأحرف: {text.length}
            </div>
          </div>
        </div>
        
        <div className="add-text-modal-footer">
          <button 
            className="btn-cancel-text" 
            onClick={onClose}
            disabled={isSaving}
          >
            إلغاء
          </button>
          <button 
            className="btn-save-text" 
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? '⏳ جاري الحفظ...' : '💾 حفظ التفريغ'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddTextModal;
